/**
 * The host config for the page the browser is actually showing.
 *
 * The worker resolves the same table for the same hostname (see `worker.ts`),
 * so the two agree by construction — this is the client half, not a second
 * source of truth. Resolved once: the hostname cannot change without a
 * navigation, and re-scanning the table on every render of every label is
 * waste.
 *
 * Browser-only. The worker must keep using `resolveHostConfig` directly, since
 * `location` there is per-request rather than ambient.
 */

import { HOSTS } from './hosts'
import { genericHost } from './hosts/generic'
import { resolveHostConfig, type HostConfig } from './host'

let resolved: HostConfig | null = null

export function currentHost(): HostConfig {
  if (resolved) return resolved
  const hostname = typeof window === 'undefined' ? '' : window.location.hostname
  // Unbranded rather than throwing. In production this cannot miss — the worker
  // would have 404'd a hostname not in the table before serving this bundle —
  // so a miss means an unusual dev setup, and a white screen is a worse answer
  // to that than a nameless one. See hosts/generic.ts for why the fallback is
  // not simply "the first host".
  resolved = resolveHostConfig(hostname, HOSTS) ?? genericHost
  return resolved
}

/** Test seam: forget the memoized answer. */
export function resetCurrentHost(): void {
  resolved = null
}
